import React from 'react';
import { cn } from "@/lib/utils";
import { EmotionLevel } from './EmotionSelector';
import { getEmotionColor, getEmotionIcon, getEmotionName, getEmotionPosition } from '@/utils/emotionHelpers';

interface EmotionFaceProps {
  emotion: EmotionLevel;
}

const EmotionFace: React.FC<EmotionFaceProps> = ({ emotion }) => {
  return (
    <div className="relative h-full flex-grow flex flex-col items-center">
      <div className={cn(
        "absolute transition-all duration-300 z-20",
        getEmotionPosition(emotion)
      )}>
        <div className={cn(
          "w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-md transform hover:scale-110 transition-all",
          getEmotionColor(emotion)
        )}>
          {getEmotionIcon(emotion)}
        </div>
        <span className="text-xs font-medium mt-1 text-center block">
          {getEmotionName(emotion)}
        </span>
      </div>
    </div>
  );
};

export default EmotionFace;
